<template>

  <SubHeading :home="home" :tabs="tabs" :currTab="currTab" color="cyan darken-3" @active="handleActive" />

  <!-- breadcrumbs -->
  <nav class="sba-collection-breadcrumb z-depth-0">
    <div class="container nav-wrapper">
      <div class="sba-collection-breadcrumb-row">
        <router-link to="/" class="breadcrumb sba-collection-crumb teal-text">
          <i class="material-icons">home</i>
          <span>Dashboard</span>
        </router-link>
        <i class="material-icons sba-collection-crumb-separator">chevron_right</i>
        <span class="breadcrumb sba-collection-crumb blue-grey-text">
          <span>Insights</span>
        </span>
        <span class="sba-collection-context">Client Insight Workspace</span>
      </div>
    </div>
  </nav>

  <!-- search layer -->
  <!-- <div class="grey lighten-4">
    <div class="container section"></div>
  </div> -->

  <div class="container insight-page-shell">
    <div class="insight-workbench sba-slide-in">
      <div class="insight-top-card">
        <div class="insight-title-block">
          <label class="active teal-text">Client Insight</label>
          <h5>Client Performance Review</h5>
          <p>Compare client utilization patterns, invoice periods, family movement, and claims behavior across the current reporting scope.</p>
        </div>

        <div class="insight-tab-bar" role="tablist" aria-label="Insight sections">
          <button
            v-for="tab in tabsState"
            :key="tab.id"
            type="button"
            :class="{ 'is-active': tab.id === currState }"
            @click="handleActiveState(tab.id)"
          >
            <i class="material-icons">{{ tab.icon }}</i>
            <span>{{ tab.title }}</span>
          </button>
        </div>
      </div>

      <!-- Executive -->
      <ReportInsight v-if="currState == 1" />
      <!-- Clients -->
      <ClientsInsight :key="clientsInsightKey" v-if="currState == 2" />
      <!-- Schemes -->
      <SchemesInsight :key="schemesInsightKey" v-if="currState == 3" />
      <!-- Report -->
      <ClaimsInsight v-if="currState == 4" />
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import useModuleNavigation from "@/composables/useModuleNavigation";
import SubHeading from "@/components/HeaderSubDiv.vue";
import ClientsInsight from "@/components/insight/ClientsInsightComponent.vue";
import SchemesInsight from "@/components/insight/SchemesInsightComponent.vue";
import ReportInsight from "@/components/insight/ReportInsightComponent.vue";
import ClaimsInsight from "@/components/insight/ClaimsInsightComponent.vue";

export default {
  name: "reportHome",
  components: { SubHeading, ClientsInsight, SchemesInsight, ReportInsight, ClaimsInsight },
  setup() {
    const home = ref(null);
    const currTab = ref(null);
    const tabs = ref([]);
    const tabsState = ref([]);
    const currState = ref(null);
    const clientsInsightKey = ref(0);
    const schemesInsightKey = ref(0);
    const { routeToTab } = useModuleNavigation();

    // start
    onMounted(() => {
      // page name
      document.title = "Insights";
    });

    // handle back
    const handleBack = () => {
      // restart menu
      currTab.value = 1;
    };

    // menu
    onMounted(() => {
      // load tab
      tabs.value.push({ id: 1, name: "Insights", title: "All", icon: null, url: "report", hash: null, });

      // set default
      currTab.value = tabs.value.find(x => x.id === 1);
      // set home
      home.value = tabs.value.find(x => x.id === 1);
    });

    // start
    onMounted(() => {
      // load tab
      tabsState.value.push({ id: 1, title: "Executive", icon: "dashboard" });
      tabsState.value.push({ id: 2, title: "Clients", icon: "business" });
      tabsState.value.push({ id: 3, title: "Schemes", icon: "layers" });
      tabsState.value.push({ id: 4, title: "Utilization Report", icon: "insert_chart" });
      // set default
      currState.value = 1;
    });

    // handle curr status
    const handleActive = (tab) => {
      currTab.value = tab;
      currState.value = 1;
      routeToTab(tab, { replace: true });
    };

    // handle curr status
    const handleActiveState = (tab) => {
      if (tab === 2) {
        clientsInsightKey.value += 1;
      }

      if (tab === 3) {
        schemesInsightKey.value += 1;
      }

      // update show and components
      currState.value = tab;
    };

    return {
      home,
      handleActive,
      handleActiveState,
      handleBack,
      currTab,
      currState,
      clientsInsightKey,
      schemesInsightKey,
      tabs,
      tabsState,
    };
  },
};
</script>

<style scoped>
.spacer {
  padding: 2px;
}

.pointer {
  cursor: default;
}

/* display */
.tab-custom-section {
  padding: 20px 0 0;
  border-top: 1px solid #ddd;
}

.insight-page-shell {
  margin-top: -14px;
  padding-bottom: 44px;
  padding-top: 0;
  position: relative;
  z-index: 1;
}

.insight-workbench {
  color: #263238;
}

.insight-top-card {
  align-items: center;
  background: #fff;
  border: 1px solid #c4d3d9;
  border-bottom-color: #e2e8eb;
  border-radius: 6px;
  box-shadow: 0 18px 32px -30px rgba(38, 50, 56, 0.72);
  display: grid;
  gap: 32px;
  grid-template-columns: minmax(260px, 0.92fr) minmax(420px, 1.25fr);
  margin-bottom: 18px;
  overflow: visible;
  padding: 28px 32px;
  position: relative;
  z-index: 2;
}

.insight-top-card::before {
  border: 1px solid #c4d3d9;
  border-bottom: 0;
  border-radius: 7px 7px 0 0;
  content: "";
  height: 18px;
  left: -1px;
  pointer-events: none;
  position: absolute;
  right: -1px;
  top: -1px;
  z-index: 1;
}

.insight-top-card > * {
  position: relative;
  z-index: 2;
}

.insight-top-card,
.insight-workbench :deep(.report-shell),
.insight-workbench :deep(.client-insight-shell),
.insight-workbench :deep(.schemes-insight-shell),
.insight-workbench :deep(.scheme-detail-shell),
.insight-workbench :deep(.client-detail-stack),
.insight-workbench :deep(.principal-detail-shell),
.insight-workbench :deep(.claims-report-shell),
.insight-workbench :deep(.executive-head),
.insight-workbench :deep(.client-insight-head),
.insight-workbench :deep(.schemes-insight-head),
.insight-workbench :deep(.claims-report-head),
.insight-workbench :deep(.filter-panel),
.insight-workbench :deep(.secondary-panel),
.insight-workbench :deep(.report-section),
.insight-workbench :deep(.report-panel),
.insight-workbench :deep(.highlight-panel),
.insight-workbench :deep(.summary-panel),
.insight-workbench :deep(.summary-tile),
.insight-workbench :deep(.metric-cell),
.insight-workbench :deep(.client-card),
.insight-workbench :deep(.scheme-card),
.insight-workbench :deep(.card-panel),
.insight-workbench :deep(.report-form-panel),
.insight-workbench :deep(.report-submit-strip) {
  animation: sbaSlideIn var(--sba-slide-duration, 260ms) ease-out both;
}

.insight-workbench :deep(.report-shell),
.insight-workbench :deep(.client-insight-shell),
.insight-workbench :deep(.schemes-insight-shell),
.insight-workbench :deep(.scheme-detail-shell),
.insight-workbench :deep(.client-detail-stack),
.insight-workbench :deep(.principal-detail-shell),
.insight-workbench :deep(.claims-report-shell) {
  gap: 16px;
  margin-top: 0;
}

.insight-workbench :deep(.executive-head),
.insight-workbench :deep(.client-insight-head),
.insight-workbench :deep(.schemes-insight-head),
.insight-workbench :deep(.claims-report-head),
.insight-workbench :deep(.filter-panel),
.insight-workbench :deep(.secondary-panel),
.insight-workbench :deep(.report-section),
.insight-workbench :deep(.report-panel),
.insight-workbench :deep(.highlight-panel),
.insight-workbench :deep(.summary-panel),
.insight-workbench :deep(.summary-tile),
.insight-workbench :deep(.metric-cell),
.insight-workbench :deep(.client-card),
.insight-workbench :deep(.scheme-card),
.insight-workbench :deep(.card-panel),
.insight-workbench :deep(.report-form-panel),
.insight-workbench :deep(.report-submit-strip) {
  border: 1px solid #c4d3d9 !important;
  border-radius: 6px !important;
  box-sizing: border-box;
}

.insight-workbench :deep(.client-detail-stack > .card-panel),
.insight-workbench :deep(.principal-detail-shell > .card-panel),
.insight-workbench :deep(.scheme-detail-shell > .card-panel),
.insight-workbench :deep(.scheme-detail-shell > .report-section) {
  margin: 0;
  width: 100%;
}

.insight-workbench :deep(.client-detail-stack > .card-panel + .card-panel),
.insight-workbench :deep(.principal-detail-shell > .card-panel + .card-panel),
.insight-workbench :deep(.scheme-detail-shell > .card-panel + .card-panel),
.insight-workbench :deep(.scheme-detail-shell > .card-panel + .report-section),
.insight-workbench :deep(.scheme-detail-shell > .report-section + .report-section) {
  border-top: 1px solid #c4d3d9 !important;
  border-radius: 6px !important;
}

.insight-top-card + :deep(.client-detail-stack),
.insight-top-card + :deep(.scheme-detail-shell) {
  gap: 16px;
  margin-top: -18px;
}

.insight-top-card + :deep(.client-detail-stack > .card-panel:first-child),
.insight-top-card + :deep(.scheme-detail-shell > :first-child) {
  border-top: 0 !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.insight-title-block h5 {
  color: #263238;
  font-weight: 700;
  line-height: 1.18;
  margin: 8px 0;
}

.insight-title-block p {
  color: #607d8b;
  font-size: 1.03rem;
  line-height: 1.45;
  margin: 0;
  max-width: 560px;
}

.insight-tab-bar {
  border: 1px solid #cfd8dc;
  border-radius: 6px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  overflow: hidden;
}

.insight-tab-bar button {
  align-items: center;
  background: #f8fafb;
  border: 0;
  border-right: 1px solid #dce4e8;
  color: #546e7a;
  cursor: pointer;
  display: flex;
  font: inherit;
  font-size: 0.88rem;
  font-weight: 700;
  gap: 10px;
  justify-content: center;
  min-height: 76px;
  padding: 0 14px;
  transition: background 0.18s ease, color 0.18s ease;
}

.insight-tab-bar button:last-child {
  border-right: 0;
}

.insight-tab-bar button:hover {
  background: #eef4f6;
  color: #263238;
}

.insight-tab-bar button.is-active {
  background: #26383f;
  color: #fff;
}

.insight-tab-bar i {
  color: #00897b;
  font-size: 1.25rem;
}

.insight-tab-bar button.is-active i {
  color: #fff;
}

@media only screen and (max-width: 992px) {
  .insight-top-card {
    grid-template-columns: 1fr;
    padding: 24px;
  }

  .insight-tab-bar {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media only screen and (max-width: 600px) {
  .insight-top-card {
    border-radius: 6px;
    padding: 22px 18px;
  }

  .insight-page-shell {
    width: 94%;
  }

  .insight-title-block h5 {
    font-size: 1.35rem;
    line-height: 1.25;
  }

  .insight-title-block p {
    font-size: 0.95rem;
  }

  .insight-tab-bar {
    grid-template-columns: 1fr;
  }

  .insight-tab-bar button {
    justify-content: flex-start;
    min-height: 54px;
  }

  .insight-workbench :deep(.executive-head),
  .insight-workbench :deep(.client-insight-head),
  .insight-workbench :deep(.schemes-insight-head),
  .insight-workbench :deep(.claims-report-head),
  .insight-workbench :deep(.filter-panel),
  .insight-workbench :deep(.secondary-panel),
  .insight-workbench :deep(.report-section),
  .insight-workbench :deep(.report-panel),
  .insight-workbench :deep(.highlight-panel),
  .insight-workbench :deep(.summary-panel),
  .insight-workbench :deep(.client-card),
  .insight-workbench :deep(.scheme-card),
  .insight-workbench :deep(.card-panel) {
    border-radius: 6px !important;
  }

  .insight-workbench :deep(table) {
    min-width: 680px;
  }

  .insight-workbench :deep(.responsive-table),
  .insight-workbench :deep(.table-wrap),
  .insight-workbench :deep(.report-table-wrap) {
    overflow-x: auto;
  }
}

@media (prefers-reduced-motion: reduce) {
  .insight-top-card,
  .insight-workbench :deep(.report-shell),
  .insight-workbench :deep(.client-insight-shell),
  .insight-workbench :deep(.schemes-insight-shell),
  .insight-workbench :deep(.scheme-detail-shell),
  .insight-workbench :deep(.client-detail-stack),
  .insight-workbench :deep(.principal-detail-shell),
  .insight-workbench :deep(.claims-report-shell),
  .insight-workbench :deep(.executive-head),
  .insight-workbench :deep(.client-insight-head),
  .insight-workbench :deep(.schemes-insight-head),
  .insight-workbench :deep(.claims-report-head),
  .insight-workbench :deep(.filter-panel),
  .insight-workbench :deep(.secondary-panel),
  .insight-workbench :deep(.report-section),
  .insight-workbench :deep(.report-panel),
  .insight-workbench :deep(.highlight-panel),
  .insight-workbench :deep(.summary-panel),
  .insight-workbench :deep(.summary-tile),
  .insight-workbench :deep(.metric-cell),
  .insight-workbench :deep(.client-card),
  .insight-workbench :deep(.scheme-card),
  .insight-workbench :deep(.card-panel),
  .insight-workbench :deep(.report-form-panel),
  .insight-workbench :deep(.report-submit-strip) {
    animation: none;
  }
}
</style>
